/* MAIVINO CUSTOM - Shop mega menu category switching.

   Its own file rather than appended to custom.js: that file ends without a
   semicolon, so anything appended after it is parsed as a continuation of its
   final expression and throws, taking the rest of the file with it.

   Delegated from document so it does not depend on when the header renders.
   Every pane is already in the DOM, so hovering only toggles a class. */
(function () {
  function activate(cat) {
    var shop = cat.closest('[data-mv-shop]');
    if (!shop) return;

    var index = cat.getAttribute('data-mv-cat');

    shop.querySelectorAll('[data-mv-cat]').forEach(function (c) {
      c.classList.toggle('is-active', c.getAttribute('data-mv-cat') === index);
    });

    shop.querySelectorAll('[data-mv-pane]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-mv-pane') === index);
    });
  }

  /* Within a pane, hovering a product swaps which set of shots is shown -
     e.g. Variety Pack's "Pouch" shows the pouches, "Cans" shows the cans.
     Panes whose artwork comes from their own products have a single set
     marked "all", which is left alone. */
  function activateShots(prod) {
    var pane = prod.closest('[data-mv-pane]');
    if (!pane) return;

    var sets = pane.querySelectorAll('[data-mv-shotset]');
    if (sets.length < 2) return;

    var index = prod.getAttribute('data-mv-shot');

    pane.querySelectorAll('[data-mv-shot]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-mv-shot') === index);
    });

    sets.forEach(function (set) {
      set.classList.toggle('is-active', set.getAttribute('data-mv-shotset') === index);
    });
  }

  function handler(e) {
    if (!e.target.closest) return;

    var cat = e.target.closest('[data-mv-cat]');
    if (cat) { activate(cat); return; }

    var prod = e.target.closest('[data-mv-shot]');
    if (prod) activateShots(prod);
  }

  document.addEventListener('mouseover', handler);
  document.addEventListener('focusin', handler);

  /* Drawer open/close for the Shop panel.

     The theme's own sidebar toggle is not bound to this link - and even where
     it is, it only collapses on a second tap when the parent's href is "#",
     so a Shop item pointing at a real collection navigated away instead of
     closing. Rather than depend on that, this owns the whole toggle: capture
     phase plus stopPropagation so the theme's handler cannot also fire and
     fight it. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var link = e.target.closest('.site-nav.style--sidebar .has-submenu > a');
    if (!link) return;

    var parent = link.parentNode;
    if (!parent.querySelector('[data-mv-shop]')) return;

    e.preventDefault();
    e.stopPropagation();

    var open = !parent.classList.contains('active');
    parent.classList.toggle('active', open);
    if (!open) parent.classList.remove('hover');

    var submenu = parent.querySelector('.submenu');
    if (submenu) {
      submenu.style.display = open ? 'block' : 'none';
      submenu.style.height = '';
      submenu.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }, true);

})();
